// test2312
(2312 && 0);
